import { useMutation, useQueryClient } from "@tanstack/react-query";
import { z } from "zod";

import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import { deleteAndValidate } from "~/shared/services/api/fetch-client.ts";

export const deletePaymentMethod = async ({
	paymentMerchantCustomerId,
	paymentMethodToken,
}: {
	paymentMerchantCustomerId: string;
	paymentMethodToken: string;
}) => {
	await deleteAndValidate(
		apiRoutes.DELETEPAYMENTMETHOD.replace(
			":paymentMerchantCustomerId",
			paymentMerchantCustomerId,
		).replace(":paymentMethodToken", paymentMethodToken),
		z.unknown(), // Assuming the response is not used or has no specific structure
	);
};

export const useDeletePaymentMethod = () => {
	const queryClient = useQueryClient();
	const { mutate, mutateAsync, isPending, error, data, reset } = useMutation<
		unknown,
		Error,
		{ paymentMerchantCustomerId: string; paymentMethodToken: string }
	>({
		mutationFn: (payload: {
			paymentMerchantCustomerId: string;
			paymentMethodToken: string;
		}) => deletePaymentMethod(payload),
		onSuccess: async () => {
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: ["customerAccounts"] }),
				queryClient.invalidateQueries({ queryKey: ["customerPaymentMethods"] }),
			]);
		},
	});

	return {
		deletePaymentMethod: mutate,
		deletePaymentMethodAsync: mutateAsync,
		isSubmitting: isPending,
		reset,
		error,
		data,
	};
};
